import { render, staticRenderFns } from "./MerchantAppInvoice.vue?vue&type=template&id=051be53c"
import script from "./MerchantAppInvoice.vue?vue&type=script&lang=js"
export * from "./MerchantAppInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports